var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGbp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_928_3418)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_928_3418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.4471 2.73826C0.897242 3.45365 0.482629 4.2782 0.241211 5.17396H3.8828L1.4471 2.73826Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7587 5.17395C13.5173 4.27823 13.1027 3.45368 12.5528 2.73828L10.1172 5.17395H13.7587Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.241211 8.82613C0.482656 9.72185 0.897269 10.5464 1.4471 11.2618L3.88271 8.82613H0.241211Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2618 1.44706C10.5464 0.897201 9.72193 0.482588 8.82617 0.241142V3.8827L11.2618 1.44706Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.73828 12.5529C3.45368 13.1028 4.27823 13.5174 5.17395 13.7589V10.1173L2.73828 12.5529Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.17393 0.241142C4.2782 0.482588 3.45365 0.897201 2.73828 1.44703L5.17393 3.88267V0.241142Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82617 13.7589C9.7219 13.5174 10.5464 13.1028 11.2618 12.553L8.82617 10.1173V13.7589Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1172 8.82613L12.5528 11.2618C13.1027 10.5464 13.5173 9.72185 13.7587 8.82613H10.1172Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9407 6.08696H7.91309H7.91306V0.0592539C7.61417 0.0203438 7.30945 0 7 0C6.6905 0 6.38583 0.0203438 6.08696 0.0592539V6.08691V6.08694H0.0592539C0.0203438 6.38583 0 6.69055 0 7C0 7.3095 0.0203438 7.61417 0.0592539 7.91303H6.08691H6.08694V13.9407C6.38583 13.9797 6.6905 14 7 14C7.30945 14 7.61417 13.9797 7.91303 13.9407V7.91309V7.91306H13.9407C13.9797 7.61417 14 7.3095 14 7C14 6.69055 13.9797 6.38583 13.9407 6.08696Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82617 8.82612L11.9498 11.9498C12.0935 11.8062 12.2305 11.656 12.3613 11.5004L9.68701 8.8261H8.82617V8.82612Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.17396 8.82613H5.17391L2.05029 11.9497C2.1939 12.0934 2.34405 12.2304 2.49969 12.3612L5.17396 9.68688V8.82613Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.17378 5.17395V5.1739L2.05014 2.05023C1.90648 2.19384 1.76943 2.34399 1.63867 2.49963L4.31297 5.17393H5.17378V5.17395Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82617 5.17395L11.9498 2.05026C11.8062 1.90659 11.6561 1.76955 11.5004 1.63882L8.82617 4.31312V5.17395Z",
    fill: "#D80027"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_928_3418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_928_3418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGbp);
export default __webpack_public_path__ + "static/media/Gbp.418896ce1658144e97853fbf7d4b44fd.svg";
export { ForwardRef as ReactComponent };